import { CbhIcon, Illustration, mergeSxProps, Text } from "@clipboard-health/ui-components";
import { Box, Stack, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { getSafeAreaPaddings } from "@src/appV2/redesign/utils/getSafeAreaPaddings";

export interface SetUpStripeAccountPageContentProps {
  stripeOnboardingUrl: string;
  sourceUI?: string;
  sx?: SxProps<Theme>;
}

export function SetUpStripeAccountPageContent(props: SetUpStripeAccountPageContentProps) {
  const { stripeOnboardingUrl, sourceUI, sx } = props;

  return (
    <Stack
      data-testid="set-up-stripe-account-page-content-container"
      sx={mergeSxProps(
        (theme) => ({
          flex: 1,
          overflow: "hidden",
          paddingX: theme.spacing(5),
          ...getSafeAreaPaddings({ bottom: true, fallbackBottom: theme.spacing(5) }),
        }),
        sx
      )}
    >
      <Stack sx={(theme) => ({ alignItems: "center", marginTop: theme.spacing(12) })}>
        <Illustration type="clipboard-plus-stripe" />
        <Text variant="h3" sx={(theme) => ({ textAlign: "center", marginTop: theme.spacing(7) })}>
          Set up your Stripe account to get paid!
        </Text>
        <Text
          variant="body1"
          sx={(theme) => ({ textAlign: "center", marginTop: theme.spacing(5) })}
        >
          We partner with Stripe to issue payments. Set up your account now! Don’t worry, it’s easy.
        </Text>
      </Stack>
      <Box sx={{ flex: 1 }} />
      <Stack
        direction="row"
        spacing={4}
        sx={(theme) => ({
          alignItems: "center",
          marginBottom: theme.spacing(7),
        })}
      >
        <CbhIcon type="bolt-filled" size="small" color={(theme) => theme.palette.text.primary} />
        <Text variant="caption">
          All debit cards and most bank account types are eligible for instant payouts!
        </Text>
      </Stack>
      <Button
        href={stripeOnboardingUrl}
        onClick={() => {
          if (!sourceUI) {
            return;
          }

          logEvent(APP_V2_USER_EVENTS.PAYMENTS_ONBOARDING_ENTRYPOINT_CLICKED, { sourceUI });
        }}
      >
        Set up Stripe account
      </Button>
    </Stack>
  );
}
